import script from "./LoaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=0ee22fc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee22fc6"]])

export default __exports__